<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <!-- 数据筛选 -->
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="评论状态" prop="isDelete">
        <el-select v-model="queryParams.isDelete" placeholder="请选择" size="small" @change="handleQuery">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="用户昵称" prop="nickname">
          <el-input v-model="queryParams.nickname" placeholder="请输入用户昵称" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="文章标题" prop="articleTitle">
        <el-input v-model="queryParams.articleTitle" placeholder="请输入文章标题" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="评论内容" prop="commentContent">
          <el-input v-model="queryParams.commentContent" placeholder="请输入评论内容" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="评论时间" >
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格操作 -->
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['system:comment:recycle']" v-if="queryParams.isDelete === 0" plain type="danger" size="mini" icon="el-icon-delete" :disabled="multiple" @click="handleToRecycle">批量删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['system:comment:remove']" v-if="queryParams.isDelete === 1" plain type="danger" size="mini" icon="el-icon-delete" :disabled="multiple" @click="handleRemoveComment">批量删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['system:comment:back']" v-if="queryParams.isDelete === 1" plain type="success" size="mini" icon="el-icon-refresh-left" :disabled="multiple" @click="handleBack">批量恢复</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>
    <!-- 表格展示 -->
    <el-table :data="commentList" @selection-change="selectionChange" v-loading="loading" >
      <!-- 表格列 -->
      <el-table-column type="selection" width="55" />
      <el-table-column prop="avatar" label="头像" align="center" width="120">
        <template slot-scope="scope">
          <img :src="scope.row.avatar" width="40" height="40" alt="" />
        </template>
      </el-table-column>
      <!-- 评论人昵称 -->
      <el-table-column prop="nickname" label="评论人" align="center" width="120"/>
      <!-- 回复人昵称 -->
      <el-table-column prop="replyNickname" label="回复人" align="center" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.replyNickname">
            {{ scope.row.replyNickname }}
          </span>
          <span v-else>无</span>
        </template>
      </el-table-column>
      <!-- 评论文章标题 -->
      <el-table-column prop="articleTitle" label="文章标题" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.articleTitle">
            {{ scope.row.articleTitle }}
          </span>
          <span v-else>无</span>
        </template>
      </el-table-column>
      <!-- 评论内容 -->
      <el-table-column prop="commentContent" label="评论内容" align="center">
        <template slot-scope="scope">
          <span v-html="scope.row.commentContent" class="comment-content" />
        </template>
      </el-table-column>
      <!-- 点赞量 -->
      <el-table-column prop="likeCount" label="点赞量" width="80" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.likeCount">
            {{ scope.row.likeCount }}
          </span>
          <span v-else>0</span>
        </template>
      </el-table-column>
      <!-- 评论时间 -->
      <el-table-column prop="createTime" label="评论时间" width="200" align="center">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span class="ml4">{{ scope.row.createTime | dateTime }} </span>
        </template>
      </el-table-column>
      <el-table-column label="来源" align="center" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.articleTitle">文章</el-tag>
          <el-tag v-else type="warning">友链</el-tag>
        </template>
      </el-table-column>
      <!-- 列操作 -->
      <el-table-column label="操作" width="160" align="center">
        <template slot-scope="scope">
          <el-button v-hasPermi="['system:comment:recycle']" v-if="scope.row.isDelete === 0" size="mini" type="text" icon="el-icon-delete" @click="handleToRecycle(scope.row)">删除</el-button>
          <el-button v-hasPermi="['system:comment:back']" v-if="scope.row.isDelete === 1" size="mini" type="text" icon="el-icon-refresh-left" @click="handleBack(scope.row)">恢复</el-button>
          <el-button v-hasPermi="['system:comment:remove']" v-if="scope.row.isDelete === 1" size="mini" type="text" icon="el-icon-delete" @click="handleRemoveComment(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />
  </div>
</template>

<script>
import {
  getCommentList,
  removeComments, backFromRecycle, moveToRecycle
} from "@/api/message/comment";
export default {
  created() {
    this.getList();
  },
  data: function() {
    return {
      loading: true,
      showSearch: true,
      options: [
        {
          value: 0,
          label: "正常"
        },
        {
          value: 1,
          label: "回收站"
        }
      ],
      commentList: [],
      // 非多个禁用
      multiple: true,
      commentIds: [],
      queryParams: {
        current: 1,
        size: 10,
        isDelete: 0,
        nickname: null,
        articleTitle: null,
        commentContent: null,
        startTime: null,
        endTime: null
      },
      dateRange: [],
      total: 0
    };
  },
  methods: {
    selectionChange(selection) {
      this.commentIds = selection.map(item => item.commentId);
      this.multiple = !selection.length;
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.queryParams.startTime=undefined;
      this.queryParams.endTime=undefined;
      this.resetForm("queryForm");

      this.handleQuery();
    },
    /** 删除评论到回收站 */
    handleToRecycle(row) {
      let ids = this.commentIds;
      if (row.commentId) {
        ids = [row.commentId];
      }
      let data = {
        ids: ids
      };
      this.$modal.confirm('是否确认删除评论ID为"' + ids + '"的数据项？').then(function() {
        return moveToRecycle(data);
      }).then(() => {
        this.$modal.msgSuccess( "删除成功");
        this.getList();
      }).catch(() => {});
    },
    /** 恢复评论 */
    handleBack(row) {
      let ids = this.commentIds;
      if (row.commentId) {
        ids = [row.commentId];
      }
      let data = {
        ids: ids
      };
      this.$modal.confirm('是否确认恢复评论ID为"' + ids + '"的数据项？').then(function() {
          return backFromRecycle(data);
        }).then(() => {
          this.$modal.msgSuccess( "恢复成功");
          this.getList();
        }).catch(() => {});
    },
    //彻底删除评论
    handleRemoveComment(row) {
      let ids = this.commentIds;
      if (row.commentId) {
        ids = [row.commentId];
      }
      let data = {
        ids: ids
      };
      this.$modal.confirm('是否确认彻底删除评论ID为"' + ids + '"的数据项？').then(function() {
          return removeComments(data);
        }).then(() => {
          this.getList();
        }).catch(() => {});
    },
    getList() {
      if( Array.isArray(this.dateRange) && this.dateRange.length>0){
        this.queryParams.startTime=this.dateRange[0];
        this.queryParams.endTime=this.dateRange[1];
      }
      getCommentList(this.queryParams).then(res => {
        this.commentList = res.rows;
        this.total = res.total;
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>
.comment-content {
  display: inline-block;
}
</style>
